import React, { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config";
import { armarFondo } from "../utils/fondoServicio";
import { useIdioma } from "../context/IdiomaContext";
import { useEstilo } from "../context/EstiloContext";
import { obtenerEstilo } from "../temas/catalogoEstilos";
import { colorTextoLegible } from "../utils/contraste";
import CargandoSpinner from "./CargandoSpinner";

/* =======================
   CARD PROFESOR GUIA
======================= */


function ProfesorCard({ item, onSeleccionarProfesor, estilo }) {
  const { t } = useIdioma();
  const disponible = item.cantidad > 0;
  const colorEstado = disponible ? "#16a34a" : "#ef4444";

  const handleClick = () => {
    if (!disponible) return;

    // 🔥 enviamos SOLO el profesor que necesita PadrePanel
    onSeleccionarProfesor({
      id: item.profesor_id,
      nombre: item.profesor_nombre,
      foto: item.profesor_foto,
    });
  };

  if (estilo.layoutDocentes === "lista") {
    // ===== ESTILO "MODERNO" — fila con foto pequeña + grado/guía + botón =====
    return (
      <button
        onClick={handleClick}
        disabled={!disponible}
        style={{
          background: "white",
          borderRadius: estilo.cardRadius,
          boxShadow: estilo.cardShadow,
          border: estilo.cardBorder,
          borderLeft: `4px solid ${colorEstado}`,
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          gap: 14,
          width: "100%",
          textAlign: "left",
          opacity: disponible ? 1 : 0.85,
          cursor: disponible ? "pointer" : "not-allowed",
        }}
      >
        {item.profesor_foto ? (
          <img
            src={item.profesor_foto}
            alt="profesor"
            style={{
              width: estilo.fotoTamano,
              height: estilo.fotoTamano,
              borderRadius: "50%",
              objectFit: "cover",
              border: `3px solid ${colorEstado}`,
              flexShrink: 0,
            }}
          />
        ) : (
          <div style={{ ...styles.sinFoto, width: estilo.fotoTamano, height: estilo.fotoTamano, flexShrink: 0 }}>
            {t("cda_sin_foto")}
          </div>
        )}

        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ fontWeight: 700, fontSize: 15, margin: 0, color: "#1e293b" }}>{item.grado}</p>
          <p style={{ fontSize: 12, margin: "2px 0 0", color: "#64748b" }}>⭐ {item.profesor_nombre}</p>
        </div>

        <div style={{ textAlign: "right", flexShrink: 0 }}>
          <div
            style={
              estilo.botonEstilo === "outline"
                ? { background: "white", color: colorEstado, border: `2px solid ${colorEstado}`, borderRadius: estilo.botonRadius, padding: "8px 16px", fontWeight: 700, fontSize: 13 }
                : { background: colorEstado, color: "white", border: "none", borderRadius: estilo.botonRadius, padding: "8px 16px", fontWeight: 700, fontSize: 13 }
            }
          >
            {t("cda_ver_horarios")}
          </div>
          <p style={{ fontSize: 11, fontWeight: 700, margin: "4px 0 0", color: colorEstado }}>
            {item.cantidad} {t("cda_disponibles")}
          </p>
        </div>
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      disabled={!disponible}
      style={{
        ...styles.cardBtn,
        borderRadius: estilo.cardRadius,
        boxShadow: estilo.cardShadow,
        border: estilo.key === "minimalista" ? estilo.cardBorder : "none",
        borderTop: `5px solid ${colorEstado}`,
        opacity: disponible ? 1 : 0.6,
        cursor: disponible ? "pointer" : "not-allowed",
      }}
    >
      {/* FOTO */}
      {item.profesor_foto ? (
        <div style={{ ...styles.fotoWrapper, border: `3px solid ${colorEstado}` }}>
          <img
            src={item.profesor_foto}
            alt="profesor"
            style={{ ...styles.fotoProfesor, width: estilo.fotoTamano * 0.57, height: estilo.fotoTamano * 0.57 }}
          />
        </div>
      ) : (
        <div style={styles.sinFoto}>{t("cda_sin_foto")}</div>
      )}

      {/* GRADO */}
      <span style={styles.profesorNombre}>{item.grado}</span>

      {/* PROFESOR */}
      <span style={styles.guiaBadge}>⭐ {item.profesor_nombre}</span>

      {/* BOTÓN ESTADO */}
      <div
        style={
          estilo.botonEstilo === "outline"
            ? { ...styles.estadoBtn, background: "white", color: colorEstado, border: `2px solid ${colorEstado}`, borderRadius: estilo.botonRadius }
            : { ...styles.estadoBtn, backgroundColor: colorEstado, borderRadius: estilo.botonRadius }
        }
      >
        {t("cda_ver_horarios")}
      </div>


{/* CANTIDAD HORARIOS */}
<div
  style={{
    ...styles.horariosCapsula,
    background: disponible ? "#ecfdf5" : "#fee2e2",
    color: disponible ? "#065f46" : "#991b1b",
  }}
>
  {item.cantidad} {t("cda_disponibles")}
</div>




    </button>
  );
}

/* =======================
   MAIN
======================= */
export default function GradosCDA({ onSeleccionarProfesor, servicioActual, fondoEfectivo, colorFondo }) {
  const { t } = useIdioma();
  const estiloGlobal = useEstilo();
  const estilo = servicioActual?.estilo_visual ? obtenerEstilo(servicioActual.estilo_visual) : estiloGlobal;
  const [grupos, setGrupos] = useState({});
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState("");

  const fondo = servicioActual?.color_fondo || styles.pageContainer.background;
  const colorTexto = colorTextoLegible(fondoEfectivo || colorFondo || fondo);

  useEffect(() => {
    axios.get(`${API_URL}/api/grados/guias`, {
      params: { servicio_id: servicioActual?.id },
    })
      .then((res) => {
        const agrupados = {};

        res.data.forEach((item) => {
          if (!agrupados[item.nivel]) agrupados[item.nivel] = [];
          agrupados[item.nivel].push(item);
        });

        setGrupos(agrupados);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  /* =======================
     ORDEN PEDAGÓGICO
  ======================= */
  const ordenNiveles = ["Kinder", "Primaria", "Secundaria"];

  // Los nombres de nivel vienen fijos de la base de datos (se usan para
  // ordenar y agrupar) — esto solo traduce lo que se MUESTRA al padre,
  // sin tocar las claves reales de "grupos".
  const traducirNivel = (nivel) => {
    const mapa = {
      Kinder: t("nivel_kinder"),
      Primaria: t("nivel_primaria"),
      Secundaria: t("nivel_secundaria"),
    };
    return mapa[nivel] || nivel;
  };

  const nivelesOrdenados = Object.keys(grupos).sort((a, b) => {
    const ia = ordenNiveles.indexOf(a);
    const ib = ordenNiveles.indexOf(b);

    if (ia === -1 && ib === -1) return a.localeCompare(b);
    if (ia === -1) return 1;
    if (ib === -1) return -1;

    return ia - ib;
  });

  return (
    <div style={{ ...styles.pageContainer, background: "transparent" }}>
      <div style={styles.container}>

        {/* HEADER */}
        <div style={styles.headerBox}>
          <h2 style={{ ...styles.title, color: colorTexto }}>{t("cda_bienvenida")}</h2>
          <p style={{ ...styles.subtitle, color: colorTexto }}>
            {t("cda_subtitulo")}
            <br />
            {t("cda_subtitulo2")}
          </p>
        </div>

        {/* BUSCADOR */}
        <div style={{ textAlign: "center", marginBottom: 30 }}>
          <input
            type="text"
            placeholder={t("cda_buscar")}
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            style={styles.buscador}
          />
        </div>

        {loading ? (
          <CargandoSpinner texto={t("cda_cargando")} color={colorTexto} />
        ) : (
          nivelesOrdenados.map((nivel) => {
            const itemsFiltrados = grupos[nivel].filter((item) =>
              (item.profesor_nombre || "")
                .toLowerCase()
                .includes(filtro.toLowerCase())
            );

            if (itemsFiltrados.length === 0) return null;

            const fondoSeccion = grupos[nivel][0]?.nivel_color
              ? armarFondo(grupos[nivel][0].nivel_color, grupos[nivel][0].nivel_color_difuminado)
              : fondo;
            const colorTextoSeccion = colorTextoLegible(fondoSeccion);

            return (
              <section
                key={nivel}
                style={{
                  ...styles.section,
                  background: fondoSeccion,
                }}
              >

                {/* TITULO NIVEL */}
                <div style={styles.nivelTitulo}>
                  <span style={{ color: colorTextoSeccion }}>{traducirNivel(nivel)}</span>
                  <div style={{ ...styles.linea, background: colorTextoSeccion, opacity: 0.5 }}></div>
                </div>

                <div
                  style={
                    estilo.layoutDocentes === "lista"
                      ? { display: "flex", flexDirection: "column", gap: 12 }
                      : styles.grid
                  }
                >
                  {itemsFiltrados.map((item) => (
                    <ProfesorCard
                      key={item.grado_id}
                      item={item}
                      estilo={estilo}
                      onSeleccionarProfesor={onSeleccionarProfesor}
                    />
                  ))}
                </div>
              </section>
            );
          })
        )}

        {!loading &&
          filtro.trim() !== "" &&
          nivelesOrdenados.every(
            (nivel) =>
              grupos[nivel].filter((item) =>
                (item.profesor_nombre || "")
                  .toLowerCase()
                  .includes(filtro.toLowerCase())
              ).length === 0
          ) && (
            <p style={{ textAlign: "center", color: "#64748b" }}>
              {t("cda_sin_resultados")}
            </p>
          )}
      </div>
    </div>
  );
}

/* =======================
   ESTILOS
======================= */
const styles = {
  pageContainer: {
    minHeight: "100vh",
    padding: "40px 10px",
    background: "#f8fafc",
  },
  container: {
    maxWidth: "1150px",
    margin: "auto",
    fontFamily: "Poppins",
  },
  headerBox: { textAlign: "center", marginBottom: "35px" },

  buscador: {
    padding: "12px 20px",
    borderRadius: "999px",
    border: "none",
    width: "min(320px, 90%)",
    fontSize: "14px",
    outline: "none",
    boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
  },

  title: { fontSize: "30px", fontWeight: "900", marginBottom: "10px" },
  subtitle: { color: "#ffffff", fontSize: "15px", lineHeight: "1.5" },

  section: {
    padding: "25px",
    borderRadius: "22px",
    marginBottom: "30px",
    background: "white",
    boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
  },

  nivelTitulo: {
    textAlign: "center",
    fontSize: "22px",
    fontWeight: "800",
    marginBottom: "20px",
  },

  linea: {
    width: "120px",
    height: "3px",
    background: "#2563eb",
    margin: "8px auto 0",
    borderRadius: "10px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(180px,1fr))",
    gap: "20px",
  },

  cardBtn: {
    background: "white",
    border: "none",
    borderRadius: "18px",
    padding: "18px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    boxShadow: "0 10px 22px rgba(0,0,0,0.12)",
  },

  fotoWrapper: { borderRadius: "50%", padding: "3px" },

  fotoProfesor: {
    width: "65px",
    height: "65px",
    borderRadius: "50%",
    objectFit: "cover",
  },

  sinFoto: {
    width: "65px",
    height: "65px",
    borderRadius: "50%",
    background: "#e5e7eb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px",
  },

  profesorNombre: { fontWeight: "700", fontSize: "15px" },

  guiaBadge: {
    fontSize: "12px",
    background: "#fef9c3",
    padding: "4px 10px",
    borderRadius: "999px",
    fontWeight: "700",
  },

  estadoBtn: {
    fontSize: "11px",
    padding: "5px 12px",
    borderRadius: "999px",
    color: "white",
    fontWeight: "700",
  },

  horariosCapsula: {
    fontSize: "12px",
    padding: "6px 14px",
    borderRadius: "999px",
    fontWeight: "700",
  },
};